import { useMutation, useQueryClient, UseMutationOptions } from "@tanstack/react-query";
import { notificationsClient } from "@core/clients";
import { MarkAsReadResponse, MarkAsReadParams } from "@core/types";

type Options = UseMutationOptions<MarkAsReadResponse, any, MarkAsReadParams>;

const useMarkAsReadMutation = (config: { options?: Options } = {}) => {
  const queryClient = useQueryClient();

  return useMutation<MarkAsReadResponse, any, MarkAsReadParams>(
    async (params: MarkAsReadParams) => {
      const { notificationId, markAllAsRead = false } = params;
      return await notificationsClient.markAsRead({
        notificationId,
        markAllAsRead,
      });
    },
    {
      onSuccess: () => {
        // Invalidate notifications queries to refetch with updated read status
        queryClient.invalidateQueries({
          queryKey: ["notifications"],
        });
        queryClient.invalidateQueries({
          queryKey: ["unread-count"],
        });

        // Force refetch all notification-related queries
        queryClient.refetchQueries({
          queryKey: ["notifications"],
        });
        queryClient.refetchQueries({
          queryKey: ["unread-count"],
        });
      },
      ...config.options,
    },
  );
};

export default useMarkAsReadMutation;
